import { InputfieldTypes } from "../../../enums/InputFieldAttributesEnums";

export const fieldNames = {
  JOBSTATUS_FILTER_NAME: "jobStatusFilter",
  CUSTOMER_FILTER_NAME: "customerNameFilter",
  SALES_PERSON_FILTER_NAME: "salesPersonFilter",
  DATE_RANGE_FILTER_NAME: "dateRangeFilter",
};

export const CrmFilterConstants = {
  FILTERS_TITLE: "Filters",
  CLEAR_FILTER_LABEL: "Clear Filter",
  DATE_PICKER_LABEL: "Date",
  SALES_PERSON_FILTER_LABEL: "Sales Person",
  JOBSTATUS_FILTER_LABEL: "Job Status",
  CUSTOMER_FILTER_LABEL: "Customer Account",
  SELECT_PLACEHOLDER: "Select",
  SHOW_RESULT_LABEL: "Show Result",
  DRAWER_HEIGHT: "100vh",
  DRAWER_WIDTH: "36rem",
};

export const jobStatusFilterOptions = [
  { label: "Build Quote", value: "Build Quote" },
  { label: "Dispatch Approved", value: "Dispatch Approved" },
  {
    label: "Internal Approval Completed",
    value: "Internal Approval Completed",
  },
  { label: "Internal Approval Draft", value: "Internal Approval Draft" },
  { label: "Job Lead", value: "Job Lead" },
  { label: "L1 Approval Pending", value: "L1 Approval Pending" },
  { label: "L1 Rejected", value: "L1 Rejected" },
  { label: "L2 Approval Pending", value: "L2 Approval Pending" },
  { label: "L2 Approved", value: "L2 Approved" },
  { label: "L2 Rejected", value: "L2 Rejected" },
  {
    label: "Material and Trucking Details",
    value: "Material and Trucking Details",
  },
  { label: "Quote Approved", value: "Quote Approved" },
  { label: "Quote Shared", value: "Quote Shared" },
];

export const filterFields = [
  {
    name: fieldNames.JOBSTATUS_FILTER_NAME,
    label: CrmFilterConstants.JOBSTATUS_FILTER_LABEL,
  },
  {
    name: fieldNames.CUSTOMER_FILTER_NAME,
    label: CrmFilterConstants.CUSTOMER_FILTER_LABEL,
  },
  {
    name: fieldNames.SALES_PERSON_FILTER_NAME,
    label: CrmFilterConstants.SALES_PERSON_FILTER_LABEL,
  },
];
